import styled from "styled-components";
export const Heading1Base = styled.h1.withConfig({
  displayName: "Heading__Heading1Base",
  componentId: "sc-1atimrb-0"
})(["font-weight:800;font-size:larger;padding:0;margin:0;"]);
export const Heading2Base = styled.h2.withConfig({
  displayName: "Heading__Heading2Base",
  componentId: "sc-1atimrb-1"
})(["font-weight:700;padding:0;margin:0;"]);